import type { Entrance, Path } from '@ahm/api-wrappers-core';
import { create } from 'zustand';
import { devtools } from 'zustand/middleware';
import type { Coords } from '../types';
import { logger } from './logger';
import { createSelectors } from './selectors';

export interface MapState {
  showMap: boolean;
  mapFullscreen: boolean;
  pinMap: number;
  activePath: Path | null;
  centerCoords: { latitude: number; longitude: number } | null;
  nearbyEntrances: Entrance[];
}

export interface MapActions {
  toggleMap: () => void;
  toggleMapFullscreen: () => void;
  setShowMap: (show: boolean) => void;
  setMapFullscreen: (fullscreen: boolean) => void;
  showPinMap: (index: number) => void;
  hidePinMap: () => void;
  setActivePath: (path: Path | null) => void;
  setCenterCoords: (coords: Coords | null) => void;
  setNearbyEntrances: (entrances: Entrance[]) => void;
}

const MAP_STORE_NAME = 'ahm.map';

export const vanillaMapStore = create<
  MapState & MapActions,
  [
    ['zustand/devtools', MapState & MapActions],
    ['zustand/persist', Pick<MapState, 'showMap' | 'mapFullscreen'>],
  ]
>(
  logger(
    devtools(
      // persist(
      (set) => {
        return {
          showMap: false,
          mapFullscreen: false,
          pinMap: -1,
          activePath: null,
          centerCoords: null,
          nearbyEntrances: [],
          toggleMap: () => {
            set((state) => ({ showMap: !state.showMap }));
          },
          toggleMapFullscreen: () => {
            set((state) => ({ mapFullscreen: !state.mapFullscreen }));
          },
          setShowMap: (show) => {
            set({ showMap: show });
          },
          setMapFullscreen: (fullscreen) => {
            set({ mapFullscreen: fullscreen });
          },
          showPinMap: (index: number) => {
            set({ pinMap: index, mapFullscreen: true });
          },
          hidePinMap: () => {
            set({ pinMap: -1, mapFullscreen: false });
          },
          setActivePath: (path) => {
            set({ activePath: path });
          },
          setCenterCoords: (coords) => {
            set({ centerCoords: coords });
          },
          setNearbyEntrances: (entrances: Entrance[]) => {
            set({ nearbyEntrances: entrances });
          },
        };
      }
      //   {
      //     name: MAP_STORE_NAME,
      //     skipHydration: true,
      //   }
      // )
    ),
    MAP_STORE_NAME
  )
);

export const useMapControl = createSelectors(vanillaMapStore);
